import {DocumentContactType} from "../../libs/enum/document-contact-type";
import {VehicleHistory} from "../../libs/enum/vehicle-history";
import {isUuid, nonBlank} from "../../libs/utils/epic.utils";

export class DocumentContactDto {

  public id!: string;
  public type!: DocumentContactType;
  // #### Contact
  public readonly contactType: string | undefined;
  public readonly number: string | undefined;
  // #### Manual input
  public manualInput: string | undefined;
  // #### Additional fields
  public contactId: string | undefined;
  public addressId: string | undefined;
  public /* readonly */ fullName: string | undefined;
  public /* readonly */ letterAddress: string | undefined;
  public readonly completeAsLetter: boolean | undefined;
  // Vehicle
  public vehicleOdometer: number | undefined;
  public vehicleHistory: VehicleHistory[] | undefined; // Semicolon separated list with history entries
  public vehicleId: string | undefined;
  public /* readonly */ vehicleName: string | undefined;

  constructor(init?: Partial<DocumentContactDto> | undefined) {
    Object.assign(this, init);
  }

  public isEmpty(): boolean {
    return !this.isContact() && !this.isManualInput() && !this.isCashSale();
  }

  public isContact(): boolean {
    return this.type === DocumentContactType.CONTACT && isUuid(this.contactId);
  }

  public isManualInput(): boolean {
    return this.type === DocumentContactType.INPUT && nonBlank(this.manualInput);
  }

  public isCashSale(): boolean {
    return this.type === DocumentContactType.CASH_SALE;
  }
}
